videojs.addLanguage('ru', {
	"Time left before start": "До начала осталось",
	"Time left before webcast start": "До начала трансляции осталось",
	"Start time of video content" : "Начало",
	"Duration of video content" : "Длительность",
	"Start time of webcast": "Начало трансляции",
	"Duration of webcast" : "Длительность трансляции",
	"Min of content": "мин",
	"Hours": "ч",
	"Day": "день",
	"Days": "дней",
	"Sdays": "дня"
});
